export default function(e){return new Promise((function(t){return setTimeout(t,e)}))}
